import React, { useEffect } from 'react';
import { Snackbar, Snack, useSnackbar, SnackbarProvider } from 'fronton-react';

export const Error = () => (
  <SnackbarProvider>
    <SnackImpl />
  </SnackbarProvider>
);

function SnackImpl() {
  const { state, addSnack } = useSnackbar();

  useEffect(() => {
    addSnack({
      id: 'snack',
    });
  }, [addSnack]);

  return (
    <Snackbar verticalPosition="bottom">
      {state.map(({ id }) => {
        return (
          <Snack
            key={id}
            id={id}
            variant="error"
            header="Что-то пошло не так"
            paragraph="Не удалась загрузить информацию о продавце"
            autoHideTimer={5000}
          />
        );
      })}
    </Snackbar>
  );
}
